import { theme } from 'Assets/Styles/theme'

const styles = {
  wrapper: {
    marginBottom: '24px',
  },

  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    marginBottom: '8px',
  },

  btnWrapper: {
    display: 'flex',

    '& > div:first-child': {
      marginRight: '16px',
    },
  },

  active: {
    '& > p': {
      color: theme.colors.primary,
    },
  },
  disabled: {
    '& > p': {
      color: '#737373',
    },
  },

  noValue: {
    '& > p': {
      color: '#B6B6B6',
    },
  },

  table: {
    textAlign: 'center',
    border: `1px solid ${theme.colors.iron}`,
    borderRadius: '4px',

    '&  p': {
      fontSize: '14px',
    },
  },

  tableContainer: {
    maxHeight: '600px',
  },

  borderRight: {
    borderRight: `1px solid ${theme.colors.iron}`,
  },

  tableHead: {
    background: '#F8F8F8',
  },

  tableHeaderCell: {
    width: '100px',
  },

  firstTableHeaderCell: {
    maxWidth: '200px',
    minWidth: '150px',
  },

  tableValue: {
    width: '100px',
  },

  outlinedInput: {
    padding: '8px 14px 8px 0',
  },

  outlinedNumberInput: {
    padding: '8px 14px 8px 0',
    textAlign: 'end',
  },

  outlinedInputRoot: {
    width: '124px',
  },

  padding4: {
    padding: '4px',
  },
  error: {
    color: 'red',
  },
  bigError: {
    color: 'red',
    fontSize: 13,
  },
}

export default styles
